<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                
                <general-information-bw-welding>
                </general-information-bw-welding>

                <targets-and-progress-from-bw-welding>
                </targets-and-progress-from-bw-welding>

                <periodical-analysis-bw-welding>
                </periodical-analysis-bw-welding>

                <material-analysis-bw-welding>
                </material-analysis-bw-welding>

                <key-information-bw-welding>
                </key-information-bw-welding>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import GeneralInformationBwWelding from '@/components/pages/project/percent_progress/bw_welding/general_information/general_information_bw_welding.vue';
import TargetsAndProgressFromBwWelding from '@/components/pages/project/percent_progress/bw_welding/targets_and_progress_from/targets_and_progress_from_bw_welding.vue';
import PeriodicalAnalysisBwWelding from '@/components/pages/project/percent_progress/bw_welding/periodical_analysis/periodical_analysis_bw_welding.vue';
import MaterialAnalysisBwWelding from '@/components/pages/project/percent_progress/bw_welding/material_analysis/material_analysis_bw_welding.vue';
import KeyInformationBwWelding from '@/components/pages/project/percent_progress/bw_welding/key_information/key_information_bw_welding.vue';

export default {
    name: 'progress_bw_welding',
    components: {
        GeneralInformationBwWelding,
        TargetsAndProgressFromBwWelding,
        PeriodicalAnalysisBwWelding,
        MaterialAnalysisBwWelding,
        KeyInformationBwWelding,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/'
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.projects.progress.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.projects.progress.progress_bw_welding.title'),
                    active: true
                }
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/bw_welding/progress_bw_welding.vue